import React from 'react';
import { User, Star, LogOut, ShoppingBag, MapPin, ChevronRight, UtensilsCrossed } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../ui/button';

const CustomerProfileView = ({ user, tenant, loyaltyPoints, myOrders, onLogout }) => {
  const navigate = useNavigate();
  const completedOrders = myOrders.filter(o => o.status === 'delivered').length;

  return (
    <div className="pb-4">
      {/* Profile Header */}
      <div className="bg-gradient-to-br from-orange-500 via-red-500 to-pink-500 -mx-4 -mt-4 px-4 pt-14 pb-8 mb-4 rounded-b-3xl shadow-lg">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-xl rounded-2xl flex items-center justify-center shadow-lg">
            <User className="w-8 h-8 text-white" />
          </div>
          <div className="flex-1">
            <h1 className="text-xl font-bold text-white">{user?.name || 'Cliente'}</h1>
            <p className="text-sm text-white/80">{user?.email || tenant?.name || 'SmartDine'}</p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-50">
          <div className="flex items-center gap-2 mb-2">
            <ShoppingBag className="w-5 h-5 text-orange-500" />
            <span className="text-xs text-gray-500 font-medium">Órdenes</span>
          </div>
          <p className="text-2xl font-bold text-gray-800">{myOrders.length}</p>
          <p className="text-xs text-gray-400">{completedOrders} completadas</p>
        </div>
        <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-4 shadow-sm border border-amber-100">
          <div className="flex items-center gap-2 mb-2">
            <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
            <span className="text-xs text-amber-600 font-medium">Puntos</span>
          </div>
          <p className="text-2xl font-bold text-amber-700">{loyaltyPoints ?? 0}</p>
          <p className="text-xs text-amber-500">Fidelidad</p>
        </div>
      </div>

      {/* Menu Items */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-50 divide-y divide-gray-50 mb-4">
        <button
          onClick={() => navigate('/customer')}
          className="w-full flex items-center gap-3 p-4 active:bg-gray-50 transition-colors"
        >
          <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
            <UtensilsCrossed className="w-5 h-5 text-orange-500" />
          </div>
          <div className="flex-1 text-left">
            <p className="font-medium text-gray-800 text-sm">Ver Menú</p>
            <p className="text-xs text-gray-500">Explorar productos</p>
          </div>
          <ChevronRight className="w-5 h-5 text-gray-400" />
        </button>

        <button
          onClick={() => navigate('/profile')}
          className="w-full flex items-center gap-3 p-4 active:bg-gray-50 transition-colors"
        >
          <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
            <User className="w-5 h-5 text-blue-500" />
          </div>
          <div className="flex-1 text-left">
            <p className="font-medium text-gray-800 text-sm">Mi Perfil</p>
            <p className="text-xs text-gray-500">Editar información personal</p>
          </div>
          <ChevronRight className="w-5 h-5 text-gray-400" />
        </button>

        {user?.addresses?.length > 0 && (
          <button
            onClick={() => navigate('/profile')}
            className="w-full flex items-center gap-3 p-4 active:bg-gray-50 transition-colors"
          >
            <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
              <MapPin className="w-5 h-5 text-green-500" />
            </div>
            <div className="flex-1 text-left">
              <p className="font-medium text-gray-800 text-sm">Mis Direcciones</p>
              <p className="text-xs text-gray-500">{user.addresses.length} guardadas</p>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400" />
          </button>
        )}
      </div>

      {/* Logout */}
      <Button
        onClick={onLogout}
        variant="outline"
        className="w-full h-12 border-red-200 text-red-500 hover:bg-red-50 rounded-xl"
      >
        <LogOut className="w-5 h-5 mr-2" />
        Cerrar Sesión
      </Button>

      {/* Tenant Info */}
      {tenant && (
        <div className="mt-6 p-4 bg-gray-50 rounded-2xl">
          <p className="text-xs text-gray-500 text-center">{tenant.name}</p>
          {tenant.address && <p className="text-xs text-gray-400 text-center mt-1">{tenant.address}</p>}
        </div>
      )}
    </div>
  );
};

export default CustomerProfileView;
